import { render } from "./Planes.vue?vue&type=template&id=f3f1d758&scoped=true"
import script from "./Planes.vue?vue&type=script&lang=js"
export * from "./Planes.vue?vue&type=script&lang=js"

import "./Planes.vue?vue&type=style&index=0&id=f3f1d758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f1d758"]])

export default __exports__